// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGDocFile = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M18.284 18.164h3.046l2.379 10.097 2.155-10.097h2.726l-3.268 13.908h-3.13l-2.378-10.695-2.392 10.695h-3.269L10.9 18.164h2.712l2.225 10.417 2.448-10.417z"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.614 11.725c.083.158.143.326.18.5V34.66c0 3.144-2.475 5.341-6.008 5.341H9.758c-3.532 0-6.008-2.197-6.008-5.34V5.952c.015-1.584.654-3.098 1.78-4.213C6.654.625 8.173 0 9.757 0h13.756c.163.039.321.095.472.167h.112c.15.09.29.198.417.32L35.238 11.21c.139.121.265.256.376.403v.112zM29.73 36.05c.917 0 2.002-.292 2.002-1.39V14.63h-7.288c-.885 0-1.734-.351-2.36-.977-.626-.626-.978-1.475-.978-2.36V3.95H9.758c-.263-.002-.524.049-.768.149-.244.1-.466.247-.652.433-.186.187-.334.408-.434.652-.1.244-.15.505-.148.769v28.706c0 1.155 1.084 1.391 2.002 1.391h19.973z"
  })]
}));
SVGDocFile.displayName = 'SVGDocFile';
export default SVGDocFile;